// extracted by mini-css-extract-plugin
module.exports = {"videoWrapper":"video-module--videoWrapper--19XZ7","videoWrapperLightbox":"video-module--videoWrapperLightbox--10fIy"};